<template>

	<header class="header-main">
		<a class="skip-to-main" href="#main-content">skip to main content</a>
		<UtilityNav :utilityNav="utilityNav"></UtilityNav>
		<SiteNavigation :siteNavigation="siteNavigation" :utilityNav="utilityNav"></SiteNavigation>
		<section v-if="Alerts && Alerts.length" aria-labelledby="headerAlerts" class="header-alerts">
			<h2 id="headerAlerts" class="sr-only">Site Announcements</h2>
			<Alerts :Alerts="Alerts"></Alerts>
		</section>
	</header>
	
</template>

<script>

	import UtilityNav from './UtilityNav.vue';
    import SiteNavigation from './SiteNavigation.vue';
    import Alerts from './Alerts.vue';
	
	export default {
		name: 'Header',
		
		props: ['utilityNav', 'siteNavigation', 'Alerts'],
		
		components: {
			UtilityNav,
            SiteNavigation,
            Alerts
		}
	}
	
</script>